import { useDialogState } from "../../../../hooks/useDialogState";
import { Box, DialogContent, DialogTitle, IconButton, Link as MuiLink } from "@mui/material";
import { DesktopOrMobileModal } from "../../modal/DesktopOrMobileModal";
import { useQuery } from "@apollo/client";
import { GET_EVENT_DIVISION_ENTRIES } from "../../../../graphql/eventDivision";
import { EntriesPageSkeleton } from "../../../routes/events/id/divisions/eventDivisionId/entries/EntriesPageSkeleton";
import { EventDivisionProvider } from "../../../routes/events/id/divisions/eventDivisionId/EventDivisionProvider";
import { Close } from "@mui/icons-material";
import { EntriesPage } from "../../../routes/events/id/divisions/eventDivisionId/entries/EntriesPage";
import { Fake } from "../../skeleton/Fake";
import { EventDivision } from "../../../../models/EventDivision";

export const EntriesModalWithTrigger = ({ eventDivisionId, children }) => {
    const [open, openModal, closeModal] = useDialogState();

    return (
        <>
            <MuiLink underline="always" color="inherit" variant="inherit" onClick={openModal}>{children}</MuiLink>
            <DesktopOrMobileModal open={open} closeModal={closeModal}>
                <EntriesModalContent eventDivisionId={eventDivisionId} closeModal={closeModal}/>
            </DesktopOrMobileModal>
        </>
    );
};
export const EntriesModalContent = ({ eventDivisionId, closeModal }) => {
    const { data } = useQuery(GET_EVENT_DIVISION_ENTRIES, {
            variables: { id: eventDivisionId },
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first"
        }),
        eventDivision = data?.eventDivision;

    if (!eventDivision) return <EntriesModalSkeleton closeModal={closeModal}/>;
    const eventDivisionObject = EventDivision(eventDivision);

    return (
        <EventDivisionProvider value={{ eventDivision, eventDivisionObject }}>
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    {eventDivision.division.name}
                    <IconButton color="inherit" size="small" onClick={closeModal}><Close/></IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <EntriesPage allEntries={[eventDivision]} isGroup={false}/>
            </DialogContent>
        </EventDivisionProvider>
    );
};

const EntriesModalSkeleton = ({ closeModal }) =>
    <div className="skeleton" role="status" aria-label="loading">
        <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Fake size={20}/>
                <IconButton color="inherit" size="small" onClick={closeModal}><Close/></IconButton>
            </Box>
        </DialogTitle>
        <DialogContent>
            <EntriesPageSkeleton/>
        </DialogContent>
    </div>;
